/* eslint new-cap: "off", no-param-reassign: "off" */
/* globals GlobalE, gle */
'use strict';

window.scriptLoaderData = (function (scriptLoaderData) {
    return JSON.parse(scriptLoaderData.innerHTML);
}(document.getElementById('globale-script-loader-data')));

/**
 * Global-e script initializer
 */
(function (w, d, u, t, o, h, m, s, l) {
    w.globaleObject = o;
    w[o] = w[o] || function () { (w[o].q = w[o].q || []).push(arguments); };
    w[o].m = m;
    w[o].v = h;
    s = d.createElement(t);
    l = d.getElementsByTagName(t)[0];
    s.async = true;
    s.src = u + '?v=' + h;
    l.parentNode.insertBefore(s, l);
}(window, document, window.scriptLoaderData.clientJsUrl, 'script', 'gle', window.scriptLoaderData.apiVersion, window.scriptLoaderData.clientJsMerchantId));
gle('SetMerchantParameters', JSON.parse(window.scriptLoaderData.clientSettings));
gle('ScriptsURL', window.scriptLoaderData.clientJsDomain);
gle('SetCookieDomain', window.scriptLoaderData.cookieDomain);
if (window.scriptLoaderData.globaleOperatedCountry) {
    gle('LoadWelcome', window.scriptLoaderData.country, window.scriptLoaderData.culture, window.scriptLoaderData.currency);
}
